let serviceName = null;
export const setServiceName = name => {
  serviceName = name;
};
export const getServiceName = () => serviceName;
//# sourceMappingURL=serviceName.js.map